package com.kinoshazam.model

data class Profile(
    val userName: String,
    val email: String,
    val avatar: String? = null,
)
